export const ImageListUploadStyles = {
    container: {
        width: '100%',
    },
    sectionTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '12px',
        color: '#333333',
        fontWeight: 600,
        marginBottom: '8px',
    },
    uploadText: {
        fontSize: '12px',
        fontWeight: 600,
        color: '#333333',
        marginLeft: '8px',
    },
    uploadButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    customFlex: {
        display: 'flex',
        alignItems: 'center',
    },
    helpText: {
        color: '#666666',
        fontSize: '12px',
        marginTop: '8px',
    },
    uploadContainer: {
        '& .ant-upload-list': {
            display: 'none',
        },
    },
    fileRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
    },
    fieldNameText: {
        marginLeft: '8px',
        marginRight: '8px',
        maxWidth: '135px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: '#666666',
    },
    deleteIcon: {
        color: '#666666',
        cursor: 'pointer',
    },
    linkIcon: {
        color: '#666666',
    },
    fileImageIcon: {
        fontSize: '16px',
    },
    fileListContainer: {
        marginBottom: '8px',
    },
};
